export * from './abschnitte.component';
export * from './abschnitte.component.module';